import React, { useEffect, useState } from "react";
import './TablaMonitoreoVistaProgramados.scss'
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { extraerHora, formateoBasico } from "../../../utilities/formateos";
import ModalCambioPrecio from "./ModalCambioPrecio";
import { getPrecios } from "./TablaMonitoreoVistaProgramadosIntegracion";

const ModalDetalleServicio = ({ data, setDataModal, setModalInfo }) => {
    const [precios,setPrecios] = useState(null)
    const [id_bitacora,setId_bitacora] = useState(null)


    const edit = (rowData, key) => {


        return (
            <td className="centrarTD" data-label="SERVICIOS"><button onClick={() => {
                setId_bitacora(rowData.ID_TR_BITACORA)
                getPrecios(rowData.ID_TR_BITACORA,setPrecios)
            }} className="dollar_button">🔄</button></td>
        )
    }

    return (
        <>
            <div className="ModalDetalleServicio">
                <div className="modalContent">
                    <div className="headerModal">
                        <div className="">Detalle de servicios</div>
                        <div className="X" onClick={() => { setDataModal(null); setModalInfo(null) }}>X</div>
                    </div>
                    <div className="bodyModal">
                        <DataTable
                            value={data}
                            scrollable
                            scrollHeight="400px"
                        >
                            <Column field="ID_TR_BITACORA" header="ID" body={(rowData) => <td data-label="NOMBRE_RUTA">{rowData.ID_TR_BITACORA}</td>} />
                            <Column field="FECHA" header="Fecha" body={(rowData) => <td data-label="FECHA">{formateoBasico(rowData.FECHA)} <div>{" (" + extraerHora(rowData.HORA_ARRANQUE) + " a " + extraerHora(rowData.HORA_LLEGADA) + ")"}</div></td>} />
                            <Column field="NOMBRE_TR_RUTA" header="Ruta" body={(rowData) => <td data-label="NOMBRE_TR_RUTA">{rowData.NOMBRE_TR_RUTA + " - " + rowData.NOMBRE_TURNO + " - " + rowData.TIPO_TR_BITACORA}<div>{"proveedor : " + rowData.PROVEEDOR}</div></td>} />
                            <Column field="ID_UNIDAD_TR_BITACORA" header="Unidad" body={(rowData) => <td data-label="ID_UNIDAD_TR_BITACORA">{rowData.ID_UNIDAD_TR_BITACORA ? rowData.ID_UNIDAD_TR_BITACORA : "Sin asignar"}</td>} />
                            <Column field="CONFIRMADA" header="C" body={(rowData) => <td data-label="CONFIRMADA">{rowData.CONFIRMADA ? "✅" : "❌"}</td>} />
                            <Column field="CANCELADO" header="T" body={(rowData) => <td data-label="CANCELADO">{rowData.CANCELADO ? '✅' : '❌'}</td>} />
                            <Column field="PAGAR" header="P" body={(rowData) => <td data-label="PAGAR">{rowData.PAGAR ? "💲" : "🚫"}</td>} />
                            <Column field="PAGO_CHOFER" header="P.O." body={(rowData) => <td data-label="PAGO_CHOFER">{rowData.PAGO_CHOFER}</td>} />
                            <Column field="PAGO_ALIADO" header="P.A." body={(rowData) => <td data-label="PAGO_ALIADO">{rowData.PAGO_ALIADO}</td>} />
                            <Column field="PRECIO_CLIENTE" header="P.C." body={(rowData) => <td data-label="PRECIO_CLIENTE">{rowData.PRECIO_CLIENTE}</td>} />
                            <Column field="acciones" header="Cambio Precio" body={edit} />
                        </DataTable>
                    </div>
                </div>

            </div>
                {
                   precios?<><ModalCambioPrecio setModalInfo={setModalInfo} setDataModal={setDataModal} setOpenModal={setPrecios} precios={precios} id_bitacora={id_bitacora}></ModalCambioPrecio></>:"" 
                }
                
            
        </>

    )
}
export default ModalDetalleServicio